import { Link } from 'react-router-dom';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  IconLucide,
  cn
} from '@yakit/ui-components';

import { useVDLStore } from '@VDL/store/VDLstore';

import type { ILevel0DataObject } from '@VDL/api/types/ILevel0Data';

export interface IVDLSidebarElementProps {
  expanded: boolean;
  levelObject: ILevel0DataObject;
}

export const VDLSidebarElement = ({
  expanded,
  levelObject
}: IVDLSidebarElementProps) => {
  const { selectedYear } = useVDLStore();

  const NUMBER_PP = levelObject?.number_pp;
  const ICON_NAME = levelObject?.icon_name;
  const NAME = levelObject?.name;
  const CODE = levelObject?.code;

  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <Link
          className={cn(
            'hover:bg-muted flex items-center justify-start gap-2 p-2 px-6 text-sm no-underline transition-colors',
            { 'justify-center px-0': !expanded }
          )}
          to={`/${CODE}?year=${selectedYear}`}
        >
          {expanded && (
            <span className="block w-[1.875rem] shrink-0 text-left text-sm">
              {NUMBER_PP}
            </span>
          )}
          <div className="flex h-5 w-4 shrink-0 items-center">
            <IconLucide name={ICON_NAME} className="h-4 w-4" />
          </div>
          {expanded && (
            <div className="line-clamp-1 w-full truncate text-left text-sm">
              {NAME}
            </div>
          )}
        </Link>
      </TooltipTrigger>
      <TooltipContent
        className="hidden max-w-[31.25rem] text-base md:block"
        side="right"
      >
        <p>{NAME}</p>
      </TooltipContent>
    </Tooltip>
  );
};
